// test1648
(1648 && 0);
